import styled from "styled-components";

export const ModalSection = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-set-document--hide{
    animation: exiting 0.5s forwards;
  }
`

export const ModalContainer = styled.article`
  width: 100%;
  max-width: 463px;
  height: 457px;
  padding: 62px 0 44px 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  position: relative;

  border-radius: 22px;
  background-color: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
`

export const ModalCloseButton = styled.button`
  width: fit-content;
  height: fit-content;

  position: absolute;
  top: 14px;
  right: 21px;

  border: 0;
  font-size: 22px;
  font-weight: bold;
  color: var(--blue02);
  background-color: transparent;
  cursor: pointer;

  transition: filter 0.3s;

  &:hover {
    filter: brightness(1.1);
  }
`

export const ModalTitle = styled.h1`
  width: 85%;
  margin: 0 auto;

  text-align: center;
  font-size: 1.9375rem;
  font-weight: bold;
  color: var(--blue00);
`

export const ModalSubtitle = styled.h2`
  width: 85%;
  margin: 0 auto;

  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 1.3125rem;
  color: var(--gray7a);
`

export const SaveButton = styled.button`
  width: 85%;
  max-width: 411px;
  height: 53px;

  text-align: center;
  line-height: 53px;
  font-size: 1.5rem;
  color: #fff;
  border-radius: 16px;
  border: 0;
  background-color: var(--blue00);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  transition: filter 0.3s;

  &:hover {
    filter: brightness(1.1);
  }
`

export const SaveLabel = styled.label`
  width: 85%;
  max-width: 411px;
  height: 53px;

  display: block;

  text-align: center;
  line-height: 53px;
  font-size: 1.5rem;
  color: #fff;
  border-radius: 16px;
  border: 0;
  background-color: var(--blue00);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  transition: filter 0.3s;

  &:hover {
    filter: brightness(1.1);
  }
`

export const InputFile = styled.input`
  display: none;
`
